<template>
  <div>
    <SchoolTeacherList v-if="roleId == 3"></SchoolTeacherList>
    <div class="cl-inner" v-else>
      <!-- 搜索 -->
      <div class="search-inner">
        <a-form layout="inline">
          <a-form-item class="name" label="老师名称">
            <a-input class="form-cell" type="text" placeholder="请输入" v-model="queryParam.keyword"></a-input>
          </a-form-item>
          <!-- 手机号 -->
          <a-form-item class="name" label="手机号">
            <a-input class="form-cell" type="text" placeholder="请输入" v-model="queryParam.teacherMobile"></a-input>
          </a-form-item>

          <!-- 老师来源 -->
          <a-form-item label="老师来源" v-if="this.roleId == 6">
            <a-select class="form-cell" placeholder="请选择" v-model="queryParam.sourceType" @change="sourceTypeChange">
              <a-select-option v-for="(item, index) in $store.getters.courseType" :key="index" :value="item.value"
                :class="{ padding0: item.value == 3 }"><span v-if="item.value != 3">{{
                  item.code
                }}</span></a-select-option>
            </a-select>
          </a-form-item>

          <!-- 审核状态 -->
          <!-- <a-form-item label="审核状态" v-if="roleId != '3'">
          <a-select
            class="form-cell"
            placeholder="请选择"
            v-model="queryParam.status"
          >
            <a-select-option value="0">待审核</a-select-option>
            <a-select-option value="3">待提交</a-select-option>
            <a-select-option value="4">初审通过</a-select-option>
            <a-select-option value="5">复审通过</a-select-option>
            <a-select-option value="1">审核通过</a-select-option>
            <a-select-option value="2">审核不通过</a-select-option>
          </a-select>
        </a-form-item> -->

          <!-- 课程方 -->
          <c-institution-select v-if="this.roleId == 6"
            :institutionCode.sync="queryParam.institutionId"></c-institution-select>

          <a-form-item class="name" label="课程方种类" v-if="this.roleId == 6">
            <a-select showSearch placeholder="请选择" :filterOption="false" :defaultActiveFirstOption="false"
              style="width: 200px" v-model="queryParam.institutionType" :allowClear="true"
              :disabled="queryParam.sourceType != 2">
              <a-select-option value="2"> 个人老师 </a-select-option>
              <a-select-option value="1"> 社会企业 </a-select-option>
              <a-select-option value="3"> 高校与协会 </a-select-option>
            </a-select>
          </a-form-item>

          <!-- 学校 -->
          <!-- <c-school-select v-if="!isSchool && !isInstitution" :schoolCode.sync="queryParam.schoolId"
        ></c-school-select/年> -->

          <a-form-item class="search-oper">
            <a-button type="primary" @click="searchTeacher()">查询</a-button>
            <a-button @click="() => (queryParam = {})">重置</a-button>
          </a-form-item>
        </a-form>
      </div>

      <!-- 操作 -->
      <div class="list-oper" v-if="isOper">
        <a-button type="primary" icon="plus" @click="openFormDrawer()">新建</a-button>
        <!-- 学校和课程方拥有导入权限 -->
        <a-button v-if="isSchool || isInstitution" class="import-excel" type="primary" icon="plus"
          @click="$refs.teacherFile.init()">导入老师</a-button>
        <a-button type="primary" class="select-row" v-if="openAllIndex == '0'"
          @click="openAllIndex = '1'">批量删除</a-button>
        <template v-if="openAllIndex == '1'">
          <a-button type="primary" class="select-row" @click="deleteSelectRow()">删除</a-button>
          <a-button type="primary" class="select-row" @click="openAllIndex = '0'">取消</a-button>
        </template>
        <a-button v-if="isSchool || isInstitution" class="import-excel" type="primary"
          @click="exportTeacher()">导出老师</a-button>
      </div>

      <!-- 表格数据 -->
      <a-table :columns="columns" :dataSource="teacherList" class="c-table" :pagination="pagination" :loading="loading"
        @change="tableChange" rowKey="userId" :rowSelection="openAllIndex != '0' ? rowSelection : null">
        <span slot="gender" slot-scope="text, record">
          <template>
            <span>{{ record.gender | gender }}</span>
          </template>
        </span>

        <span slot="statusText" slot-scope="text, record">
          <template v-if="$store.state.common.tags">
            <!-- <a-tag
            style="border-radius: 50%;vertical-align: middle;padding: 3px;"
            :color="
              record.statusText === '审核通过'
                ? '#68CC2E'
                : record.statusText === '审核不通过'
                ? '#FA5151'
                : '#FFA91F'
            "
          >
          </a-tag> -->

            {{ record.statusText }}
          </template>
        </span>

        <span slot="schoolName" slot-scope="text, record">
          <template>
            <span>{{ record.institutionName || record.schoolName }}
              <!-- 添加高协标签 -->
              <a-tag v-if="record.institutionType == 3" color="blue">
                高协
              </a-tag>
            </span>
          </template>
        </span>
        <span slot="serviceSchoolNameList" slot-scope="text, record">
          <template>
            <span>{{
              record.serviceSchoolNameList
                ? record.serviceSchoolNameList.join(',')
                : ''
            }}</span>
          </template>
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="submitTeacher(record.id)" v-if="record.status == 3 || record.status == 2">提交审核 &nbsp;</a>
          <!-- <a-divider
          type="vertical"
          v-if="record.status == 3 || record.status == 2"
        /> -->

          <a @click="showDetail(record.userId)">详情 &nbsp;</a>

          <template v-if="isOper">
            <!-- <a-divider
            type="vertical"
            v-if="record.status == '2' || record.status == '3' || roleId == '3'"
          /> -->
            <a @click="openFormDrawer(record.userId)" v-if="
              record.status == '2' ||
              record.status == '3' ||
              roleId == '3' ||
              record.status == '1' ||
              record.status == '4' ||
              record.status == '5' ||
              record.status == '0'
            ">修改</a>
          </template>
        </span>
        <span slot="schoolName" slot-scope="text, record">
          <template>
            <span>{{ record.schoolName || record.institutionName }}
              <a-tag v-if="record.sourceType == 2 && record.institutionType == 3" color="blue">
                高协
              </a-tag>
            </span>
          </template>
        </span>
      </a-table>
      <!-- 详情 -->
      <SchoolTeacherDetail v-if="showDrawer" :showDrawer.sync="showDrawer" @refresh="getList()" @edit="openFormDrawer"
        :teacherUserId="teacherUserId">
      </SchoolTeacherDetail>
      <!-- 老师新建/修改 -->
      <TeacherFormModal v-show="formDrawer" :showDrawer.sync="formDrawer" @refresh="getTeacherList()" :userId="userId"
        ref="formRef">
      </TeacherFormModal>

      <teacher-detail-modal ref="teacherDetail" @updateTeacher="updateTeacher"
        @back-modify="backModify"></teacher-detail-modal>

      <teacher-file-modal ref="teacherFile" @refreshList="getTeacherList()"></teacher-file-modal>
    </div>
  </div>
</template>
<script>
import teacher from '../../api/teacher'

import TeacherFormModal from './components/SchoolTeacherForm'

import SchoolTeacherDetail from './components/SchoolTeacherDetail.vue'

import TeacherDetailModal from './TeacherDetailModal'

import TeacherFileModal from './components/TeacherFileModal'

import CUpload from '../../components/CUpload'

import CRichtext from '../../components/CRichtext'

import CSchoolSelect from '../../components/CSchoolSelect'

import CInstitutionSelect from '../../components/CInstitutionSelect'

import SchoolTeacherList from './SchoolTeacherList.vue'
let columns = [
  {
    title: '老师ID',
    dataIndex: 'id',
    width: 120,
  },
  {
    title: '老师名称',
    dataIndex: 'nickname',
    width: 120,
  },
  {
    title: '审核状态',
    dataIndex: 'statusText',
    scopedSlots: { customRender: 'statusText' },
    width: 100,
  },
  {
    title: '性别',
    dataIndex: 'gender',
    scopedSlots: { customRender: 'gender' },
    width: 60,
  },
  {
    title: '执教年限/年',
    dataIndex: 'teachingYears',
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
  },
  {
    title: '老师来源',
    dataIndex: 'sourceTypeText',
    scopedSlots: { customRender: 'sourceTypeText' },
  },
  {
    title: '组织名称',
    dataIndex: 'schoolName',
    scopedSlots: { customRender: 'schoolName' },
  },
  {
    title: '课程方种类',
    dataIndex: 'institutionTypeName',
    scopedSlots: { customRender: 'institutionTypeName' },
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    sorter: true,
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    width: 200,
  },
]

export default {
  name: 'teacherList',
  data() {
    return {
      teacherList: [], //老师数据
      columns: JSON.parse(JSON.stringify(columns)), //列标识数据
      queryParam: {}, //查询参数
      pagination: {
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
        showLessItems: true,
        showSizeChanger: true,
      }, //分页数据对象
      loading: true,
      isOper: false, //是否具有操作权限
      isSchool: false, //学校登录着
      isInstitution: false, //课程方登录着
      openAllIndex: '0', //是否开启全部选择
      selectedRowKeys: [], //table选中的项目list
      roleId: '', //角色权限
      formDrawer: false,
      showDrawer: false,
      userId: null,
      teacherUserId: null,
    }
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys) => {
          this.selectedRowKeys = selectedRowKeys
        },
      }
    },
  },
  components: {
    TeacherFormModal,
    TeacherDetailModal,
    CUpload,
    CRichtext,
    CSchoolSelect,
    CInstitutionSelect,
    TeacherFileModal,
    SchoolTeacherList,
    SchoolTeacherDetail
  },
  methods: {
    showDetail(id) {
      this.showDrawer = true
      this.teacherUserId = id
    },
    openFormDrawer(id) {
      this.formDrawer = true
      this.userId = id ? id : null
      this.$refs.formRef.backTop()
      if (id) {
        this.$refs.formRef.init(id)
      }
    },
    sourceTypeChange(value) {
      if (value == 1) {
        this.queryParam.institutionType = undefined
      }
    },
    //表格删除选中的学生
    deleteSelectRow() {
      if (this.selectedRowKeys.length == 0) {
        this.$message.error('请勾选删除项')
        return
      }
      teacher.batchDelete({ ids: this.selectedRowKeys.join() }).then((res) => {
        this.$message.success('删除成功')
        this.getTeacherList({ currentPage: this.pagination.current, pageSize: this.pagination.pageSize })
        this.selectedRowKeys = []
      })
    },

    chooseFile(e) {
      teacher.importTeacher({ fileName: e.target.files[0] }).then((res) => {
        this.$message.success('导入成功')
        //刷新
        this.getTeacherList({ currentPage: this.pagination.current, pageSize: this.pagination.pageSize })
        e.target.value = ''
      })
    },

    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      let obj = this.queryParam
      obj.currentPage = pagination.current
      obj.pageSize = pagination.pageSize
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${sorter.order == 'ascend' ? 'asc' : 'desc'
          }`
      }
      this.getTeacherList(obj)
    },

    //新增一个老师
    addTeacher(teacher) {
      // this.teacherList.unshift(teacher)
      this.getTeacherList(this.queryParam)
    },

    //修改一个老师
    updateTeacher(teacher) {
      // for (let i in this.teacherList) {
      //   if (this.teacherList[i].id == teacher.id) {
      //     this.$set(this.teacherList, i, teacher)
      //   }
      // }
      this.getTeacherList(this.queryParam)
    },

    //查询老师
    searchTeacher() {
      this.queryParam.currentPage = 1
      this.queryParam.pageSize = 10
      this.getTeacherList(this.queryParam)
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        this.queryParam
      )}`
    },

    //老师列表
    getTeacherList(params) {
      this.loading = true
      if (this.roleId != 6) {
        this.columns = [
          {
            title: '老师ID',
            dataIndex: 'id',
            // width: 60,
          },
          {
            title: '老师名称',
            dataIndex: 'nickname',
            width: 120,
          },
          {
            title: '审核状态',
            dataIndex: 'statusText',
            scopedSlots: { customRender: 'statusText' },
            width: 100,
          },
          {
            title: '性别',
            dataIndex: 'gender',
            scopedSlots: { customRender: 'gender' },
            width: 60,
          },
          {
            title: '执教年限/年',
            dataIndex: 'teachingYears',
          },
          {
            title: '手机号',
            dataIndex: 'mobile',
          },

          {
            title: '组织名称',
            dataIndex: 'schoolName',
            scopedSlots: { customRender: 'schoolName' },
          },

          {
            title: '创建时间',
            dataIndex: 'gmtCreate',
            sorter: true,
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
            width: 200,
          },
        ]
      }
      teacher.getTeacherList_all(params).then((res) => {
        res.data.list.forEach(item => {
          item.teachingYears = item.teachingYears == 0 ? '无经验' : item.teachingYears == 3 ? '1~3年' : item.teachingYears == 5 ? '4~5年' : item.teachingYears == 10 ? '6~10年' : item.teachingYears == 11 ? '10年以上' : ''
        })
        this.teacherList = res.data.list
        this.loading = false
        //平台角色特殊处理
        if (this.roleId == '6') {
          res.data.pagination.total = res.data.pagination.total
        }
        //分页信息
        this.pagination = res.data.pagination
      })
    },

    //是否有操作权限
    judgeIsOper(param) {
      this.$store.dispatch('getUserInfo').then((res) => {
        this.roleId = res.accRole.id.toString()
        if (['3', '4'].indexOf(this.roleId) != -1) {
          this.isOper = true
        } else {
          this.isOper = false
        }

        //是学校吗
        this.isSchool = this.roleId == '3' ? true : false
        //是课程方吗
        this.isInstitution = this.roleId == '4' ? true : false
        this.getTeacherList(param)
      })
    },
    // 提交审核按钮
    submitTeacher(teacherId) {
      teacher.submitTeacher(teacherId).then((res) => {
        this.$message.success('提交审核成功')
        this.getTeacherList(this.queryParam)
      })
    },

    //刷新学校
    refreshSchool() {
      this.getTeacherList()
    },

    // 退回修改
    backModify(id) {
      this.openFormDrawer(id)
    },

    // 导出老师
    exportTeacher() {
      let _this = this
      this.$confirm({
        title: '注意',
        okText: '确定',
        cancelText: '取消',
        icon: 'exclamation-circle',
        content: '注意：仅支持导出1万条数据记录，如需导出更多数据请提出人工导出申请',
        onOk() {
          _this.$store.dispatch('getUserInfo').then((userInfo) => {
            let params = {}
            if (userInfo.roleId == 3) {
              params = { schoolId: userInfo.schoolId }
            } else if (userInfo.roleId == 4) {
              params = { institutionId: userInfo.institutionId }
            }
            Object.assign(params, _this.queryParam)
            teacher.exportTeacher(params).then((res) => {
              window.location.href = res.data
            })
          })
        },
      })
    },
  },

  created() {
    if (this.$route.query.params) {
      this.queryParam = JSON.parse(this.$route.query.params)
    } else {
      this.queryParam = {}
    }
    this.judgeIsOper(this.queryParam)
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}

.search-oper {
  button {
    margin: 0px 5px;
  }
}

.list-oper {
  margin: 20px 0px 30px;
}

.person-scope {
  width: 100px;
  text-align: center;
}

.max-person {
  border-left: none;
}

.person-gap {
  width: 30px;
  border-left: 0;
  pointer-events: none;
  background: #fff;
}

.import-excel {
  display: inline-block;
  margin-left: 20px;
  position: relative;

  input {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 110px;
    height: 32px;
    z-index: 999;
    opacity: 0;
  }

  .download {
    display: inline-block;
    margin-left: 20px;
    text-decoration: underline;
    color: $primary-color-dark;
  }
}
</style>
